import { commonEventAttributes, eventsTableSpecificAttributes } from "components/events/Constants";
import { SECURITY_EVENT_STATUSES } from "security-app/hooks/api/securityEventsAPI.types";
import OwnerFilter from "security-app/components/SecurityEvents/Alerts/OwnerFilter";
import TacticTechniqueFilter from "security-app/components/SecurityEvents/Alerts/MitreCategories/TacticTechniqueFilter";
import EventDefinitionTypeFilter from "security-app/components/SecurityEvents/Alerts/EventDefinitionTypeFilter";
import RiskScoreFilter from "security-app/components/SecurityEvents/Alerts/RiskScoreFilter";
import AssociatedInvestigationsFilter from "security-app/components/SecurityEvents/Alerts/AssociatedInvestigationsFilter";
import AssociatedAssetsFilter from "security-app/components/SecurityEvents/Alerts/AssociatedAssetsFilter";
import usePermissions from "hooks/usePermissions";
export const SECURITY_EVENTS_ENTITY_TABLE_ID = "security_events";
export const RISK_SCORE_RANGE = { min: 0, max: 100 };
const SLICING_SORT_OPTIONS = {
  riskScore: {
    title: "Risk Score",
    value: "risk_score"
  },
  priority: {
    title: "Priority",
    value: "priority"
  }
};
export const securityEventDetailsAttributes = [
  ...commonEventAttributes,
  {
    id: "status",
    title: "Status",
    type: "STRING",
    filterable: true,
    sliceable: true,
    filter_options: Object.entries(SECURITY_EVENT_STATUSES).map(([value, title]) => ({ value, title }))
  },
  {
    id: "scores",
    title: "Risk Score",
    type: "STRING",
    sortable: true,
    filterable: true,
    sliceable: true,
    filter_component: RiskScoreFilter
  },
  {
    id: "event_id",
    title: "ID",
    type: "STRING",
    sortable: true
  },
  {
    id: "associated_assets",
    title: "Associated Assets",
    type: "STRING",
    filterable: true,
    sliceable: true,
    slice_sort_options: [SLICING_SORT_OPTIONS.riskScore, SLICING_SORT_OPTIONS.priority],
    filter_component: AssociatedAssetsFilter,
    permissions: ["asset:read"]
  },
  {
    id: "associated_investigations",
    title: "Associated Investigations",
    type: "STRING",
    filterable: true,
    sliceable: true,
    slice_sort_options: [SLICING_SORT_OPTIONS.priority],
    sortable: true,
    filter_component: AssociatedInvestigationsFilter
  },
  {
    id: "fields",
    title: "Additional Fields",
    sortable: false
  }
];
export const categoryKey = "category";
export const attributes = [
  ...securityEventDetailsAttributes.filter((type) => type.id !== "event_definition_type"),
  ...eventsTableSpecificAttributes,
  {
    id: "owner",
    title: "Owner",
    type: "STRING",
    filterable: true,
    sliceable: true,
    permissions: ["users:list"],
    filter_component: OwnerFilter
  },
  {
    id: "event_definition_type",
    title: "Event Definition Type",
    type: "STRING",
    filterable: true,
    filter_component: EventDefinitionTypeFilter
  },
  {
    id: categoryKey,
    title: "Tactic/Technique",
    type: "STRING",
    filterable: true,
    filter_component: TacticTechniqueFilter
  }
];
export const useSecurityEventsTableElements = () => {
  const { isPermitted } = usePermissions();
  const canReadAssets = isPermitted("asset:read");
  const defaultDisplayedAttributes = [
    "message",
    "scores",
    "owner",
    "alert",
    "status",
    "timestamp",
    "associated_investigations",
    "associated_assets"
  ];
  const defaultColumnOrder = [
    "message",
    "scores",
    categoryKey,
    "owner",
    "alert",
    "status",
    "priority",
    "timestamp",
    "key",
    "event_definition_id",
    "event_definition_type",
    "group_by_fields",
    "remediation_steps",
    "event_id",
    "associated_investigations",
    "associated_assets"
  ];
  if (!canReadAssets) {
    const index = defaultDisplayedAttributes.indexOf("associated_assets");
    if (index > -1) defaultDisplayedAttributes.splice(index, 1);
    const columnIndex = defaultColumnOrder.indexOf("associated_assets");
    if (columnIndex > -1) defaultColumnOrder.splice(columnIndex, 1);
  }
  return {
    defaultLayout: {
      entityTableId: SECURITY_EVENTS_ENTITY_TABLE_ID,
      defaultPageSize: 20,
      defaultSort: { attributeId: "timestamp", direction: "desc" },
      defaultDisplayedAttributes,
      defaultColumnOrder
    }
  };
};
